var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 18.9425C21.7993 18.9425 23.2982 17.4437 23.2982 15.5922C23.2982 13.7407 21.7993 12.2418 19.9478 12.2418C19.9363 12.2418 19.9248 12.2418 19.9133 12.2418C19.6182 9.57767 17.3527 7.5 14.6003 7.5C12.4268 7.5 10.56 8.79567 9.72433 10.6548C9.6975 10.6548 9.67067 10.651 9.64383 10.651C7.35533 10.651 5.5 12.5063 5.5 14.7948C5.5 17.0833 7.35533 18.9387 9.64383 18.9387",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 18.9397C21.8702 18.8702 23.298 17.3991 23.298 15.592C23.298 13.7405 21.7992 12.2416 19.9477 12.2416H19.9132C19.9028 12.1484 19.8901 12.0559 19.875 11.9641C20.2421 11.8263 20.6399 11.751 21.0554 11.751C22.7804 11.751 24.2026 13.0543 24.3904 14.7333H24.4134C25.5749 14.7333 26.5179 15.6763 26.5179 16.8378C26.5179 17.9993 25.5749 18.9423 24.4134 18.9423L20.0803 18.9397Z",
    fill: "#CAD1E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3183 20.651L10.9872 22.9565L12.8055 22.4693L11.4744 24.7748",
    stroke: "url(#paint0_linear_4805_26905)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3183 20.651L14.9872 22.9565L16.8055 22.4693L15.4744 24.7748",
    stroke: "url(#paint1_linear_4805_26905)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3183 20.651L18.9872 22.9565L20.8055 22.4693L19.4744 24.7748",
    stroke: "url(#paint2_linear_4805_26905)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_26905",
    x1: 11.4092,
    y1: 20.8946,
    x2: 12.3836,
    y2: 24.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4805_26905",
    x1: 15.4092,
    y1: 20.8946,
    x2: 16.3836,
    y2: 24.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4805_26905",
    x1: 19.4092,
    y1: 20.8946,
    x2: 20.3836,
    y2: 24.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.83f98ececb778936912ae5d4db9ffea0.svg";
export { ForwardRef as ReactComponent };